import { Button, Sheet, SheetTrigger } from '@e2n/ui';
import { EinstellungenSheetContent } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/EinstellungenSheetContent';
import { useEinstellungenSheetContext } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/EinstellungenSheetContext/useEinstellungenSheetContext';
import { useEinstellungenFormContext } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/Forms/EinstellungenForm/useEinstellungenFormContext';
import { faCog } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function EinstellungenSheet() {
  const { open, setOpen } = useEinstellungenSheetContext();
  const form = useEinstellungenFormContext();

  return (
    <Sheet
      open={open}
      onOpenChange={(open) => {
        form.reset();
        setOpen(open);
      }}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon">
          <FontAwesomeIcon icon={faCog} />
        </Button>
      </SheetTrigger>
      <EinstellungenSheetContent />
    </Sheet>
  );
}
